import { createStore } from '../../../../core/utils/stateManagers';

// 상태 스토어 상태 인터페이스
export interface StatusState {
    isLoadingGlobal: boolean;
    isLoadingTabData: boolean;
    isLoadingInitialMount: boolean;
}

// 초기 상태
const initialState: StatusState = {
    isLoadingGlobal: false,
    isLoadingTabData: false,
    isLoadingInitialMount: true,
};

// 상태 스토어 생성
export const createStatusStore = () => {
    const store = createStore<StatusState>(initialState);

    return {
        ...store,

        // 전역 로딩 상태 설정
        setIsLoadingGlobal: (loading: boolean) => store.update(state => ({ ...state, isLoadingGlobal: loading })),

        // 탭 데이터 로딩 상태 설정
        setIsLoadingTabData: (loading: boolean) => store.update(state => ({ ...state, isLoadingTabData: loading })),

        // 초기 마운트 로딩 상태 설정
        setIsLoadingInitialMount: (loading: boolean) => store.update(state => ({ ...state, isLoadingInitialMount: loading })),

        // 전역 로딩 상태를 처리하는 래퍼 함수
        withGlobalLoading: async <T>(fn: () => Promise<T>): Promise<T> => {
            store.update(state => ({ ...state, isLoadingGlobal: true }));
            try {
                return await fn();
            } finally {
                store.update(state => ({ ...state, isLoadingGlobal: false }));
            }
        },

        // 스토어 초기화
        reset: () => store.set(initialState),
    };
};

// 싱글톤 인스턴스 생성 및 내보내기
export const searchStatusStore = createStatusStore();
